import { createBrowserRouter } from 'react-router-dom';
import { PageShell } from '@/components/layout/PageShell';
import { HomePage } from '@/pages/HomePage';
import { AboutPage } from '@/pages/AboutPage';
import { TeamPage } from '@/pages/TeamPage';
import { ProjectsPage } from '@/pages/ProjectsPage';
import { ProjectDetailPage } from '@/pages/ProjectDetailPage';
import { ServicesPage } from '@/pages/ServicesPage';
import { BlogPage } from '@/pages/BlogPage';
import { BlogPostPage } from '@/pages/BlogPostPage';
import { ContentsPage } from '@/pages/ContentsPage';
import { ContentDetailPage } from '@/pages/ContentDetailPage';
import { CareersPage } from '@/pages/CareersPage';
import { RoleDetailPage } from '@/pages/RoleDetailPage';
import { ApplyPage } from '@/pages/ApplyPage';
import { ContactPage } from '@/pages/ContactPage';
import { LegalPage } from '@/pages/LegalPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Marketing-site route tree. Every route renders inside <PageShell> so the
 * header, footer, and floating CTA are consistent.
 *
 * Per 04-INFORMATION_ARCHITECTURE.md and 05-FEATURES.md.
 */
export const router = createBrowserRouter([
  {
    element: <PageShell />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/team', element: <TeamPage /> },
      { path: '/projects', element: <ProjectsPage /> },
      { path: '/projects/:slug', element: <ProjectDetailPage /> },
      { path: '/services', element: <ServicesPage /> },
      { path: '/blog', element: <BlogPage /> },
      { path: '/blog/:slug', element: <BlogPostPage /> },
      { path: '/careers', element: <CareersPage /> },
      { path: '/careers/:slug', element: <RoleDetailPage /> },
      { path: '/contents', element: <ContentsPage /> },
      { path: '/contents/:slug', element: <ContentDetailPage /> },
      { path: '/careers/:slug/apply', element: <ApplyPage /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '/legal/:slug', element: <LegalPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);